import type { SxProps, Theme } from "@mui/material";
import { MenuItem, TextField } from "@mui/material";
import { useRollMaterials } from "../hooks/useRollsBlanks";

interface RollMaterialSelectorProps {
	value: number | null;
	onChange: (value: number | null) => void;
	label?: string;
	fullWidth?: boolean;
	size?: "small" | "medium";
	required?: boolean;
	error?: boolean;
	helperText?: string;
	includeAll?: boolean;
	disabled?: boolean;
	sx?: SxProps<Theme>;
}

export const RollMaterialSelector = ({
	value,
	onChange,
	label = "Roll Material",
	fullWidth = false,
	size = "small",
	required = false,
	error = false,
	helperText,
	includeAll = false,
	disabled = false,
	sx,
}: RollMaterialSelectorProps) => {
	const { data: materials = [], isLoading } = useRollMaterials();

	return (
		<TextField
			select
			label={label}
			value={value ?? ""}
			onChange={(e) =>
				onChange(e.target.value === "" ? null : Number(e.target.value))
			}
			size={size}
			fullWidth={fullWidth}
			required={required}
			disabled={disabled || isLoading}
			error={error}
			helperText={helperText}
			sx={
				{
					minWidth: 120,
					width: fullWidth ? "100%" : undefined,
					...sx,
				} as SxProps<Theme>
			}
			slotProps={{
				select: {
					sx: { width: "100%" },
				},
			}}
		>
			{includeAll && (
				<MenuItem value="">
					<em>All</em>
				</MenuItem>
			)}
			{!includeAll && !required && (
				<MenuItem value="">
					<em>None</em>
				</MenuItem>
			)}
			{materials.map((material) => (
				<MenuItem key={material.Id} value={material.Id}>
					{material.Name}
				</MenuItem>
			))}
		</TextField>
	);
};
